import { ArrowDropDownRounded as r } from "@mui/icons-material";
import { styled as t } from "./styled2.mjs";
import { MenuItem as o, ListItemIcon as i, listItemIconClasses as n, svgIconClasses as a, Divider as d, dividerClasses as s } from "@mui/material";
t("button")`
	width: 100%;
	background-color: ${({ theme: e }) => e.palette.grey[900]};
	display: flex;
	max-width: 164px;
	border-radius: ${({ theme: e }) => e.tokens.radius[8]};
	padding: 3px 8px;
	height: 38px;
	border: 1px solid;

	&:hover,
	&[aria-expanded='true'] {
		cursor: pointer;
		background-color: ${({ theme: e }) => e.palette.action.hover};
		border-color: ${({ theme: e }) => e.palette.grey[900]};
	}
`;
t(r)`
	color: ${({ theme: e }) => e.palette.common.white};
	margin-left: ${({ theme: e }) => e.spacing(1)};
	align-self: center;
	transform: ${({ $isOpen: e }) => e ? "rotate(180deg)" : "unset"};
`;
const l = t(o)`
	padding: 5px 8px;
	height: 26px;
	min-height: auto;
	background-color: transparent;
`, m = t(i)`
	font-size: 16px;
	&.${n.root} {
		width: 16px;
		min-width: auto;
		margin-right: ${({ theme: e }) => e.spacing(1)};
	}
	.${a.root} {
		font-size: 1em;
	}
`, u = t(d)`
	&.${s.root} {
		margin: 0;
	}
`, $ = t("div")`
	display: flex;
	align-items: center;

	height: ${({ theme: e }) => e.spacing(5.5)};

	padding: ${({ theme: e }) => e.spacing(1)};
	margin: 0;

	border-radius: ${({ theme: e }) => e.tokens.radius[8]};

	color: ${({ theme: e }) => e.palette.text.secondary};
`, h = t("div")`
	padding: ${({ theme: e }) => e.spacing(1)};
	padding-bottom: 0;
`;
export {
  u as Divider,
  $ as StyledEmailWrapper,
  h as StyledLanguageSelectorWrapper,
  l as UserMenuItem,
  m as UserMenuItemIcon
};
//# sourceMappingURL=styles67.mjs.map
